import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navigation } from './Navigation';
import { SiteFooter } from './SiteFooter';

/** Shared header + footer wrapping every route. */
export function SiteLayout() {
  const {
    pathname
  } = useLocation();
  // Each page starts at the top, like a real page load.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen w-full bg-black text-white selection:bg-red-600 selection:text-white flex flex-col" data-id="element-543" data-mp="3dv1e9qorjaa9">
      <Navigation data-id="element-544" data-mp="3itkzfovj8i1k" />
      <div className="flex-1" data-id="element-545" data-mp="3it2tu1mzcrgz">
        <Outlet data-id="element-546" data-mp="3nm5tmricox5m" />
      </div>
      <SiteFooter data-id="element-547" data-mp="3nmxd53yob4fj" />
    </div>;
}